import { render } from "./ContentImages.vue?vue&type=template&id=f650bc50"
import script from "./ContentImages.vue?vue&type=script&lang=js"
export * from "./ContentImages.vue?vue&type=script&lang=js"

import "./ContentImages.vue?vue&type=style&index=0&id=f650bc50&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__